<template>
  <b-card>
    <b-card-header>
      <h2>Welcome to Shades of Polaris, LLC!</h2>
    </b-card-header>
    <b-card-body>
      <p>
        Please check out our projects under development under both <router-link to="/bac">Board &amp; Cards Games</router-link>
        and <router-link to="/tabletop">Tabletop Games</router-link>.      
      </p>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: 'HomeView',
  data () {
    return {
    }
  }
}
</script>

<style scoped>
  h2 {
    text-align: center;
  }
  p {
    text-align: left;
  }
</style>
